
import WDElement from '../wd-element';

export default class WDCarouselItem extends WDElement {

	#body;
	#caption;
	#model;

	constructor(model)
	{
		super().classList.add('carousel-item','wd-carousel-item');
		this.model = model;
	};
	
	connectedCallback()
	{
		super.connectedCallback();

		this.closest('.wd-carousel').addEventListener('slide:begin',evt => {
			if (evt.detail.to == this) this.trigger('slide:show');
			else if (evt.detail.from == this) this.trigger('slide:hide');
		});

		this.closest('.wd-carousel').addEventListener('slide:end', evt =>
		{
			if (evt.detail.from == this) this.trigger('slide:hidden');
			else if (evt.detail.to == this) this.trigger('slide:shown');
		});
	};

	get model() { return this.#model; };
	set model(val) { this.#model = val; };

	get body()
	{
		if (!this.#body)
		{
			this.#body = wdc('<div class="wd-carousel-item-body"/>');
			this.append(this.#body);
		}
		
		return this.#body;
	};

	set caption(captionContent)
	{
		if (!this.#caption)
		{
			this.#caption = wdc('<div class="carousel-caption"/>');
			this.#caption.insertAfter(this.body);
			this.#caption.append(captionContent);
		}
		
		return this.#caption;
	};
	
	get carousel()
	{
		return this.closest('wd-carousel');
	};
	
	get index()
	{
		return this.carousel.itemArray.indexOf(this);
	};

	get isFirst()
	{
		return this.index === 0;
	}

	get isLast()
	{
		return this.index === this.carousel.items.length - 1;
	}

	/**
	 * view this slide
	 */
	view()
	{
		this.carousel.view( this.index() );
	};

};

customElements.define('wd-carousel-item',WDCarouselItem);

